import { EntityBase } from "../entity.base";
import { Product } from "../product/product";

export class Category extends EntityBase {
    public Name: string = '';
    public ParentCategoryId?: number | undefined;
    public ParentCategory: Category | undefined;
    public Products: Array<Product> = [];
    public Categories: Array<Category> = [];
}